import { BaseError } from '@/common';
import {
  MepDataSource,
  MyEmergencyPlanRegisterFormSchema,
  MyEmergencyPlanFormSchema,
  MyEmergencyPlanRepository,
  MyEmergencyPlanGetPlanDeepLinkSchema,
} from '@/features';
import { Either, left, right } from 'fp-ts/lib/Either';

export class MyEmergencyPlanRepositoryImpl implements MyEmergencyPlanRepository {
  dataSource: MepDataSource;

  constructor(dataSource: MepDataSource) {
    this.dataSource = dataSource;
  }

  async getMepDownloadUrl(data: MyEmergencyPlanFormSchema): Promise<Either<BaseError, string>> {
    try {
      const response = await this.dataSource.getMepDownloadUrl(data);
      return right(response);
    } catch (error) {
      if (error instanceof BaseError) {
        return left(error);
      }

      return left(new BaseError('Failed to get download URL'));
    }
  }

  async sendMepByEmail(params: { data: MyEmergencyPlanFormSchema; email: string }): Promise<Either<BaseError, void>> {
    try {
      await this.dataSource.sendMepByEmail({ plan: params.data, email: params.email });
      return right(undefined);
    } catch (error) {
      if (error instanceof BaseError) {
        return left(error);
      }

      return left(new BaseError('Failed to send MEP by email'));
    }
  }

  async registerForPreparednessEvent(data: MyEmergencyPlanRegisterFormSchema): Promise<Either<BaseError, void>> {
    try {
      await this.dataSource.registerForPreparednessEvent(data);
      return right(undefined);
    } catch (error) {
      if (error instanceof BaseError) {
        return left(error);
      }

      return left(new BaseError('Failed to register for preparedness event'));
    }
  }

  async getPlanDeepLink(data: MyEmergencyPlanGetPlanDeepLinkSchema): Promise<Either<BaseError, string>> {
    try {
      const response = await this.dataSource.getPlanDeepLink(data);
      return right(response);
    } catch (error) {
      if (error instanceof BaseError) {
        return left(error);
      }

      return left(new BaseError('Failed to get plan deep link'));
    }
  }
}
